import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type SocialDialogueStateType = {
  value: boolean;
};

const initialState = {
  value: false,
} as SocialDialogueStateType;

export const socialDialogue = createSlice({
  name: "socialDialogue",
  initialState,
  reducers: {
    reset: () => initialState,
    open: (state) => {
      state.value = true;
    },
    close: (state) => {
      state.value = false;
    },
  },
});

export const { open, close, reset } = socialDialogue.actions;
export default socialDialogue.reducer;
